import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconAxisZSizeS from './IconAxisZ_size_s';

const props: CreateIconArguments = {
  l: IconAxisZSizeS,
  m: IconAxisZSizeS,
  s: IconAxisZSizeS,
  xs: IconAxisZSizeS,
  name: 'IconAxisZ',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
